import { defineMessages } from 'react-intl';

export default defineMessages({
    tooltip: {
        id: '_.select_amount_with_slider.tooltip',
        defaultMessage: `If you don't take the full {amount} today, you've got until {date} to come back for the rest.`
    }
});
